var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCornerLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#075DA7",
    d: "M25.236 15.296c0 1.071-.373 1.576-1.12 1.576H4.119c-.132 2.577 1.928 3.84 6.167 3.84h1.12l11.276-.061c1 0 1.494.626 1.494 1.89 0 1.01-.494 1.444-1.433 1.444-2.615 0-14.708.06-15.576-.06-2.24-.193-3.866-.698-4.926-1.577C.747 21.156 0 19.832 0 18.256v-6.738C0 9.376 1.191 7.8 3.493 6.789c1.685-.757 3.735-1.131 6.167-1.131h7.48c2.05 0 3.735.374 5.23 1.07 1.927.88 2.866 2.264 2.866 4.092v4.476zm-3.927-4.223c0-1.384-2.735-2.081-8.227-2.081-.676 0-1.362 0-2.11.07-.686 0-.999.061-.938.061-4.048 0-6.107.697-6.107 2.142v2.142l17.439.027-.057-2.361z",
    transform: "rotate(-13 22.738 4.567)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B42626",
    d: "M24.43 1.89a1.39 1.39 0 01-1.374 1.383H2.181A1.39 1.39 0 01.808 1.89v-.505A1.39 1.39 0 012.181 0h20.875a1.39 1.39 0 011.373 1.384v.505z",
    transform: "rotate(-13 22.738 4.567)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerLogoMobile);
export default __webpack_public_path__ + "static/media/corner-logo-mobile.844d20c0ae757f4fe7a8da4e08528963.svg";
export { ForwardRef as ReactComponent };